var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUploadComplete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    fillRule: "evenodd",
    d: "M14.705 8.395l-3.784 4.969-1.633-2.087c-.34-.435-.97-.511-1.404-.17-.435.34-.512.969-.171 1.402l2.43 3.107c.19.242.48.383.789.383h.007c.309 0 .6-.147.788-.394l4.569-6c.335-.44.25-1.066-.19-1.4-.441-.335-1.067-.25-1.401.19zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.477 2 2 6.478 2 12s4.477 10 10 10 10-4.478 10-10S17.523 2 12 2z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadComplete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload_complete.faa1519f.svg";
export { ForwardRef as ReactComponent };